export const ITEMS_PER_VIEWPORT_MD = 2;
export const ITEMS_PER_VIEWPORT_LG_XL = 3;
export const GAP_BETWEEN_ITEMS = 16;
export const HERO_POSITION_OFFSET = 20;
export const DEFAULT_POSITION_OFFSET = 0;
export const LARGE_VIEWPORT_MARGIN = 40;
export const DEFAULT_VIEWPORT_MARGIN = 10;
export const PEEKING_MULTIPLIER = 2;
export const ACTIVE_INDEX_OFFSET_MULTIPLIER = 1;
export const NEGATIVE_MULTIPLIER = -1;